import React from 'react'
import {
  TextInputField,
  Pane,
  Text,
  Menu,
  Button,
  Strong,
  MinusIcon
} from 'evergreen-ui'

import { connect } from 'react-redux'

import TimeRangePicker from './timeRangePicker'
import { getCurrentTime } from '../util'

class EditCard extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      startTime: this.props.pricing.startTime,
      endTime: this.props.pricing.endTime,
      currentTime: getCurrentTime('HH:mm:ss'),
      pricingConfig: '',
      tempType: ''
    }
    this.baseState = this.state
  }

  onCloseDialog = () => {
    const { editPrice } = this.props

    this.setState({
      ...this.baseState
    })

    editPrice(false)
  }

  saveTemporary = async (e, type) => {
   
    await this.setState({ tempType: type })
  }

  handleTimeChange = (timeChangeData, time) => {
   
    let { mutateTime, indexB } = this.props
    let { tempType } = this.state

    this.setState({ ...timeChangeData })
    mutateTime(indexB, time, tempType)
  }

  async componentDidMount () {
    // let { pricing } = this.props;
    // let modifiedPriceSlots = await modifyPriceSlots(pricing);
    // this.setState({
    // 	pricingConfig: modifiedPriceSlots,
    // });
  }

  render () {
    const {
      pricing,
      index,
      handleAddDiscountSlot,
      handleRemoveDiscountSlot,
      mutateVolumeDiscount,
      indexB,
      mutateDiscount,
      mutateHourlyPrice,
      isInvalid
    } = this.props

    let indexA = pricing && pricing.slotDiscount && pricing.slotDiscount.length

    const { currentTime, endTime, startTime, pricingConfig } = this.state

    return (
      <Pane
        marginBottom={30}
        background={'white'}
        padding={8}
        marginTop={20}
        border='default'
        borderRadius={3}
        elevation={1}
      >
        <TimeRangePicker
          fromTime={startTime}
          toTime={endTime}
          currentTime={currentTime}
          handleTimeChange={this.handleTimeChange}
          step={30}
          saveTemporary={this.saveTemporary}
        />
        <Pane marginTop={10}>
          <Strong>Hourly Price</Strong>
          <TextInputField
            onChange={e => mutateHourlyPrice(e, indexB)}
            marginBottom={15}
            label=''
            placeholder={'Add price per hour'}
            isInvalid={pricing.isInvalid}
            validationMessage={pricing.isInvalid && 'This field is required'}
            value={pricing.pricingAmount}
          />
        </Pane>
        <Menu.Divider marginTop={20} />
        {pricing
          ? pricing.slotDiscount.map((pricing, index) => (
              <Pane flexDirection='column' borderBottom>
                <Pane
                  marginTop={15}
                  display={'flex'}
                  flexDirection={'row'}
                  justifyContent={'space-between'}
                >
                  <Pane
                    marginRight={10}
                    display={'flex'}
                    flexDirection={'column'}
                    width={'50%'}
                  >
                    <Strong size={400} color={'#425A70'}>
                      Volume Discount
                    </Strong>
                    <TextInputField
                      placeholder={'Slot'}
                      label=''
                      onChange={e => mutateVolumeDiscount(e, indexB, index)}
                      value={pricing[0]}
                    />
                  </Pane>
                  <Pane
                    marginLeft={10}
                    display={'flex'}
                    flexDirection={'column'}
                    width={'50%'}
                  >
                    <Strong size={400} color={'#425A70'}>
                      Discount
                    </Strong>
                    <TextInputField
                      placeholder={'%'}
                      label=''
                      onChange={e => mutateDiscount(e, indexB, index)}
                      value={pricing[1]}
                    />
                  </Pane>
                </Pane>
                {index != 0 ? (
                  <Pane
                    textAlign='right'
                    flexDirection={'row'}
                    justifyContent='flex-end'
                  >
                    <MinusIcon 
                      alignItems="flex-end" 
                      size={8}
                    />
                    <Text
                      onClick={() => handleRemoveDiscountSlot(indexB, index)}
                      color='muted'
                    >
                      Remove
                    </Text>
                  </Pane>
                ) : null}
              </Pane>
            ))
          : null}
        <Pane
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-end'}
          justifyContent={'flex-end'}
        >
          <Pane
            marginTop={20}
            marginBottom={20}
            height={20}
            padding={2}
            flexDirection={'row'}
          >
            <Button
              height={30}
			  borderRadius={"5px"}
              width={70}
              marginLeft={10}
              iconBefore={'add'}
              onClick={() => handleAddDiscountSlot(indexB)}
            >
              <Text marginLeft={5} marginTop={3}>
                Add
              </Text>
            </Button>
          </Pane>
        </Pane>
      </Pane>
    )
  }
}

const mapStateToProps = ({ deskUserData }) => ({
  deskUserData
})

export default connect(mapStateToProps)(EditCard)
